import List from './list';
import Pagination from './pagination';

export default {
	List,
	Pagination
}